import React, {useState, useRef, useEffect} from 'react'

import useOnWindowResize from '@/hooks/use-on-window-resize'
import {Text} from '@helios/shared/styles/typography'

import * as s from './accordion.styles'

interface Props {
    title: string
    initialOpen?: boolean
    className?: string
    children: React.ReactNode
}

const AccordionItem = ({children, title, initialOpen = false, className}: Props) => {
    const [isActive, setActive] = useState(initialOpen)
    const [height, setHeight] = useState(0)
    const ref = useRef<HTMLDivElement>(null)

    const updateHeight = () => {
        !!ref.current && setHeight(ref.current.scrollHeight)
    }

    useEffect(updateHeight, [isActive])
    useOnWindowResize(updateHeight)

    return (
        <s.Item className={className}>
            <s.ClickableHeader onClick={() => setActive((active) => !active)}>
                <s.Header isActive={isActive}>
                    <Text as="span">{title}</Text>
                </s.Header>
            </s.ClickableHeader>

            <s.ContentWrapper ref={ref} $height={height} $isActive={isActive}>
                <s.Content>{children}</s.Content>
            </s.ContentWrapper>
        </s.Item>
    )
}

export default AccordionItem
